// import {
//   MenuPostionEnum
// } from "ahm-angular";

// export const MENU = {
//   position: MenuPostionEnum.left,
//   title: "intranetFront",
//   items: [{
//     label: 'Inicio',
//     icon: 'pi pi-home',
//     items: [{
//         label: 'Inicio',
//         icon: 'pi pi-fw pi-home',
//         routerLink: '/home'
//       }
//     ]
//   }]
// }
import { MenuPostionEnum } from "ahm-angular";

export const MENU = {
  position: MenuPostionEnum.top,
  title: "Ahora+  La intranet de Ahorramas",
  items: [
    {
      label: 'Inicio',
      icon: 'pi pi-home',
      routerLink: '/home'
    },
    {
      label: 'Opciones Desplegables',
      items: [
        {
          label: 'Opción 1',
          icon: 'pi pi-fw pi-star',
          routerLink: '/opcion1'
        },
        {
          label: 'Opción 2',
          icon: 'pi pi-fw pi-check',
          routerLink: '/opcion2'
        },
        {
          label: 'Opción 3',
          icon: 'pi pi-fw pi-calendar',
          routerLink: '/opcion3'
        }
      ]
    },
    {
      label: 'Opciones Desplegables',
      items: [
        {
          label: 'Opción 1',
          icon: 'pi pi-fw pi-star',
          routerLink: '/opcion1'
        },
        {
          label: 'Opción 2',
          icon: 'pi pi-fw pi-check',
          routerLink: '/opcion2'
        },
        {
          label: 'Opción 3',
          icon: 'pi pi-fw pi-calendar',
          routerLink: '/opcion3'
        }
      ]
    },
    {
      label: 'Opciones Desplegables',
      items: [
        {
          label: 'Opción 1',
          icon: 'pi pi-fw pi-star',
          routerLink: '/opcion1'
        },
        {
          label: 'Opción 2',
          icon: 'pi pi-fw pi-check',
          routerLink: '/opcion2'
        },
        {
          label: 'Opción 3',
          icon: 'pi pi-fw pi-calendar',
          routerLink: '/opcion3'
        }
      ]
    },
    {
      icon: 'pi pi-fw pi-calendar',
      routerLink: '/otra-pestaña'
    },
    {
      icon: 'pi pi-fw pi-calendar',
      routerLink: '/otra-pestaña'
    },
    {
      icon: 'pi pi-fw pi-calendar',
      routerLink: '/otra-pestaña'
    },
    {
      icon: 'pi pi-fw pi-calendar',
      routerLink: '/otra-pestaña'
    },
    {
      icon: 'pi pi-fw pi-calendar',
      routerLink: '/otra-pestaña'
    },
    {
      icon: 'pi pi-fw pi-calendar',
      routerLink: '/otra-pestaña'
    }
  ]
};
